// extracted by mini-css-extract-plugin
export var typingIndicator = "_hl-0";